import { useEffect, useState } from 'react'
import { FormattedMessage, defineMessages } from 'react-intl'
import { FormCheckbox, FormDropDown } from '../forms/final-form-fields'
import FormAutosuggest from '../forms/final-form-fields/FormAutosuggest'
import get from 'lodash/get'
import API from 'api'

const messages = defineMessages({
  refType: {
    id: 'ref_type',
    defaultMessage: 'Referral type',
  },
})

export default function StaffCheckoutForm({ values }) {
  const [userPaymentMethod, setUserPaymentMethod] = useState({})
  useEffect(() => {
    if(values.account) {
      setUserPaymentMethod({})
      API(`account/${values.account}/payment-methods/`)
        .get()
        .then((data) => {
          setUserPaymentMethod(data)
        })
    }
  }, [values.account])

  const brand = get(
    userPaymentMethod,
    'lastMethod.data.card.brand',
    get(userPaymentMethod, 'lastMethod.data.brand')
  )
  const last4 = get(
    userPaymentMethod,
    'lastMethod.data.card.last4',
    get(userPaymentMethod, 'lastMethod.data.last4')
  )

  return (
    <div className='fields'>
      <p className='section-title'>
        <FormattedMessage
          id='padi_staff'
          defaultMessage='PADI Travel staff inputs (optional)'
        />
      </p>
      <div className='shadow-block'>
        <div className='main-form'>
          <div className='form-row mbm'>
            <FormAutosuggest
              name='account'
              label='User account'
              placeholder='User account'
              fieldLabel='fullName'
              fieldId='id'
              url='account/suggest/'
              className='form-group'
            />
          </div>
          {userPaymentMethod && userPaymentMethod.lastMethod && (
            <div className='form-row'>
              <FormCheckbox
                name='paymentMethod'
                label={`Do you want to use the customer's main credit card which we have on file - (${brand} - ${last4})`}
                value={userPaymentMethod.lastMethod.id}
              />
            </div>
          )}
          <div className='form-row mbm'>
            <FormAutosuggest
              name='affiliateId'
              label='Affiliate'
              placeholder='Search affiliate by id or name'
              fieldLabel='title'
              fieldId='memberNumber'
              url='booking/affiliate/autosuggest/'
              className='form-group'
            />
          </div>
          <div className='form-row mbm'>
            <FormAutosuggest
              name='affiliateCampaign'
              label='Affiliate campaign'
              placeholder={
                values.affiliateId
                  ? 'Search campaign by id or name'
                  : 'You should select affiliate first'
              }
              fieldLabel='title'
              fieldId='code'
              disabled={!values.affiliateId}
              queryParams={{
                affiliate_profile__member_number: values.affiliateId,
              }}
              url='booking/affiliate/campaign/autosuggest/'
              className='form-group'
            />
          </div>
          <div className='form-row'>
            <FormDropDown
              name='referralType'
              title={messages.refType}
              isArrayCollection
              options={window.info.checkout.ORDER_REFERAL_KIND}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
